import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import { IconColor } from '@freelancer/ui/icon';
import { ListItemPadding, ListItemType } from '@freelancer/ui/list-item';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontType, FontWeight, TextSize } from '@freelancer/ui/text';
import { TooltipPosition } from '@freelancer/ui/tooltip';

@Component({
  selector: 'app-user-profile-verification-item',
  template: `
    <fl-bit *ngIf="!loading" class="ProfileVerificationItem">
      <fl-bit [flMarginRight]="Margin.XXXSMALL">
        <fl-tooltip
          [message]="tooltipText"
          [position]="TooltipPosition.TOP_CENTER"
        >
          <fl-bit class="ProfileVerificationItem-label">
            <fl-icon
              [color]="iconColour"
              [flMarginRight]="Margin.XXSMALL"
              [name]="icon"
            ></fl-icon>
            <fl-text [color]="FontColor.DARK" [fontType]="FontType.SPAN">
              {{ labelText }}
            </fl-text>
          </fl-bit>
        </fl-tooltip>
      </fl-bit>

      <fl-bit>
        <fl-icon
          *ngIf="status || !isOwner"
          [color]="iconColour"
          [name]="statusIconType"
        >
        </fl-icon>
        <fl-link
          *ngIf="!status && isOwner && !hideAction"
          class="ProfileVerificationItem-action"
          flTrackingLabel="{{ flTrackingLabel }}Link"
          [link]="link"
          [fragment]="fragment"
        >
          {{ actionText }}
        </fl-link>
      </fl-bit>
    </fl-bit>

    <fl-bit *ngIf="loading">
      <fl-grid>
        <fl-col [col]="10">
          <fl-loading-text [rows]="1" [padded]="false"></fl-loading-text>
        </fl-col>
        <fl-col [col]="2">
          <fl-loading-text [rows]="1" [padded]="false"></fl-loading-text>
        </fl-col>
      </fl-grid>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-verification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileVerificationItemComponent implements OnInit {
  ButtonColor = ButtonColor;
  FontColor = FontColor;
  TextSize = TextSize;
  FontType = FontType;
  FontWeight = FontWeight;
  IconColor = IconColor;
  ListItemPadding = ListItemPadding;
  ListItemType = ListItemType;
  Margin = Margin;
  TooltipPosition = TooltipPosition;

  @Input() flTrackingLabel: string;
  @Input() fragment: string;
  @Input() icon: string;
  @Input() isOwner: boolean;
  @Input() link: string;
  @Input() loading: boolean;
  @Input() status: boolean;
  @Input() labelText: string;
  @Input() actionText: string;
  @Input() tooltipText: string;
  @Input() hideAction: boolean;

  iconColour: IconColor;
  statusIconType: 'ui-tick' | 'ui-minus-thin';

  ngOnInit(): void {
    this.iconColour = this.status ? this.IconColor.SUCCESS : this.IconColor.MID;
    this.statusIconType = this.status ? 'ui-tick' : 'ui-minus-thin';
  }
}
